import * as React from 'react';

import './Transcript.css';

import { IAlignedWord } from '../api';
import { Word } from './Word';

interface IProps {
  words: IAlignedWord[],
  currentTime: number,
  onClick: (id: string, t: number) => void,
  trackID: string,
  transcript: string,
}

class Paragraph extends React.Component<IProps> {

  public shouldComponentUpdate(nextProps: IProps) {
    const {words} = this.props;

    const firstWord = words[0]
    const lastWord = words[words.length - 1];

    const startTime = firstWord.start;
    const endTime = lastWord.start + lastWord.duration;

    if (nextProps.currentTime < (startTime - 1)) {
        return false;
    }
    if (nextProps.currentTime > (endTime + 1)) {
        return false;
    }
    
    if (nextProps.currentTime === this.props.currentTime) {
        return false;
    }

    return true;
  }

  public render() {
    const {words} = this.props;

    return (<p>{words.map(this.renderWord)}</p>);
  }

  private renderWord = (word: IAlignedWord, i: number) => {
    const {
      words,
      currentTime,
      transcript,
    } = this.props;

    const start = word.textStart;

    let end;
    if (words[i + 1]) {
      end = words[i + 1].textStart;
    } else {
      end = words[i].textEnd;
    }
    const slice = transcript.slice(start, end);

    return (<Word
      onClick={this.onClickWord}
      word={word}
      text={slice}
      currentTime={currentTime}
      index={i}
      key={i} />);
  }

  private onClickWord = (word: IAlignedWord) => {
    this.props.onClick(this.props.trackID, word.start);
  }

}

export default Paragraph;



// WEBPACK FOOTER //
// ./src/components/Paragraph.tsx